import * as amplitude from "@amplitude/unified";
import { TRACKING_ENABLED } from "~/utils/tracking";

const { VITE_ENVIRONMENT } = import.meta.env;

interface EventParams {
  action: string;
  label?: string;
  value?: number;
  code?: string;
}

const hasStatisticsConsent = () => {
  if (!TRACKING_ENABLED) {
    return false;
  }

  const cookieYesConsent = window.getCkyConsent ? window.getCkyConsent() : null;
  const consentViaCookieYes =
    cookieYesConsent && cookieYesConsent.categories.analytics;
  const noCmp = !window.getCkyConsent;

  // handleConsentChangeForAmplitude initializes the SDK in development even when
  // CookieYes withholds analytics consent. Without the same override here,
  // autocaptured events would flow while manually tracked ones were dropped.
  return noCmp || consentViaCookieYes || VITE_ENVIRONMENT === "development";
};

export const amplitudeEventFactory =
  (category: string): any =>
  ({ action, ...params }: EventParams): void => {
    if (!hasStatisticsConsent()) {
      return;
    }

    amplitude.track(action, { ...params, category });
  };
